import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '../../utils/date-utils';

@Pipe({
    name: 'minutesToTime',
})
export class MinutesToTimePipe implements PipeTransform {
    transform(minutes: number): unknown {
        return new DateUtils().timeConvert(minutes).replace(':', 'h');
    }
}
